import { SystemDescriptions } from "src/common/descriptions";
import { ExpenditureRecord } from "src/common/models/expenditureRecord";
import { formatToCurrency, formatToDisplayDatetime } from "src/common/util";
import { SummaryType } from "src/components/SearchableTable/types";
import { searchableTableUtils } from "src/components/SearchableTable/utils";
import { TableCellElement } from "./TableCellElement";

const descriptions = SystemDescriptions.PAGES.ACCOUNT_PAYABLES.EXPENDITURE_RECORDS

export enum ColumnsKeys {
    NO = 'key',
    DATETIME = 'datetime',
    DESCRIPTION = 'description',
    CASH = 'cash',
    TRANSACTION = 'transaction',
    CASHBOX_CATEGORY = 'categoryName',
    SERVICE_CATEGORY = 'serviceCategory',
    TOTAL = 'total',
    ACTIONS = 'ACTIONS',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={value}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.DATETIME,
        dataIndex: ColumnsKeys.DATETIME,
        key: ColumnsKeys.DATETIME,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={formatToDisplayDatetime(value)}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.DESCRIPTION,
        dataIndex: ColumnsKeys.DESCRIPTION,
        key: ColumnsKeys.DESCRIPTION,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={value}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.SERVICE_CATEGORY,
        dataIndex: ColumnsKeys.SERVICE_CATEGORY,
        key: ColumnsKeys.SERVICE_CATEGORY,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={value}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.TOTAL,
        dataIndex: ColumnsKeys.TOTAL,
        key: ColumnsKeys.TOTAL,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={formatToCurrency(value)}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.CASH,
        dataIndex: ColumnsKeys.CASH,
        key: ColumnsKeys.CASH,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={formatToCurrency(value)}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.TRANSACTION,
        dataIndex: ColumnsKeys.TRANSACTION,
        key: ColumnsKeys.TRANSACTION,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={formatToCurrency(value)}
            />
        },
    },
    {
        title: descriptions.TABLE_COLUMNS.CASHBOX_CATEGORY,
        dataIndex: ColumnsKeys.CASHBOX_CATEGORY,
        key: ColumnsKeys.CASHBOX_CATEGORY,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value, record: ExpenditureRecord) => {
            return <TableCellElement
                isDeleted={record.isDeleted}
                value={value}
            />
        },
    },
];

export const summaryColumns: Partial<Record<ColumnsKeys, SummaryType>> = {
    [ColumnsKeys.CASH]: SummaryType.SUM,
    [ColumnsKeys.TRANSACTION]: SummaryType.SUM,
    [ColumnsKeys.TOTAL]: SummaryType.SUM,
    [ColumnsKeys.NO]: SummaryType.COUNT,
}